import { connect } from 'react-redux'
import Register from '../../components/employer/account/register.component'
import {
  registerFormSubmit,
  closeRegisterSnackbar,
  loadSignUpFromSite
} from '../../actions/employer/index'

/**
 *
 * @author  Pragya Gupta
 *
 */

const mapStateToProps = (state) => {
  return {
    registerForm: state.registerForm,
    showSpinner: state.register.showSpinner,
    showSnackbar: state.register.showSnackbar,
    showFailSnackbar: state.register.showFailSnackbar,
    errorMessage: state.register.errorMessage
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    registerFormSubmit: (email, contact_name, company_name, password) =>
      dispatch(registerFormSubmit(email, contact_name, company_name, password)),
    closeRegisterSnackbar: () => dispatch(closeRegisterSnackbar()),
    loadSignUpFromSite: () => dispatch(loadSignUpFromSite())
  }
}

// Passing the result of mapStateToProps, mapDispatchToProps, and the parent props
const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps)

// Connect does not modify the component class passed to it,
// instead it returns a new, connected component class
const RegisterContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(Register)

export default RegisterContainer
